import axios from "axios";
// import LocalStorage from "./local-storage";

const instance = axios.create();

instance.defaults.timeout = 10000;
instance.defaults.withCredentials = true;

instance.interceptors.request.use(
  (req) => {
    // req.headers.Authorization = `PS ${LocalStorage.get('ps-token')}`;
    // const lang = LocalStorage.get('ps-lang');
    // if (lang) req.headers["X-PS-Locale"] = lang;
    return req;
  },
  (err) => Promise.reject(err)
);

instance.interceptors.response.use(
  (res) => {
    const data = res.data || res;
    // data.code 为兼容旧接口
    const code = (data.status || data.code).toLowerCase();
    // 网络成功状态下的请求结果判断
    if (data && code === "ok") {
      return data;
    }
    const errorData = {
      type: data && code === "Realname Required" ? "verify_error" : "data_error",
      data,
      config: res.config,
    };
    return Promise.reject(errorData);
  },
  (error) => {
    const { data, status, config } = error.response;
    const dataErrorStatus = [401, 409, 422];
    let errorData;
    if (dataErrorStatus.indexOf(status) !== -1) {
      errorData = {
        type: "data_error",
        data,
        config,
      };
    } else {
      errorData = {
        type: "net_error",
        data: error,
      };
    }
    return Promise.reject(errorData);
  }
);

export default instance;
